import React, {useContext} from 'react';
import { FormattedMessage, IntlContext } from 'react-intl';
import { useFormikContext, FieldArray } from 'formik';
import FileUpload from '../../../components/FileUpload';
import {constants} from '../../../constants';
import { bytesToNearestUnitStr } from '../../../components/components/utils';

export default function AttachmentsTabBody(props) {
	const { values, setFieldTouched } = useFormikContext();
	const { messages } = useContext(IntlContext);

	const formatFileName = (fileName) => {
		const maxLength = 200;
		const extensionMatch = fileName.match(/\.[0-9a-zA-Z]+$/i);
		const extension = extensionMatch ? extensionMatch[0] : "";
		const nameWithoutExtension = fileName.replace(extension, "");

		let trimmedName = nameWithoutExtension;

		if (nameWithoutExtension.length > maxLength) {
			trimmedName = nameWithoutExtension.slice(0, maxLength) + "..."
		}

		return trimmedName + extension;
	}

	return (
		<>
			<div className="form-group col-md-12 text-left">
				<h2><FormattedMessage id="sima.tab.header.3"/></h2>
				<div className="form-group col-md-12">
					<p><FormattedMessage id="sima.upload.description.3" values={{strong: chunks => <strong>{chunks}</strong>}} /></p>
					<p><FormattedMessage id="sima.upload.description.4" values={{i: (chunks) => <i>{chunks}</i>, english: (chunks) => <span lang="en">{chunks}</span>, french: (chunks) => <span lang="fr">{chunks}</span>}} /></p>
					<p><FormattedMessage id="sima.upload.description.4.1" /></p>
					<p><FormattedMessage id="sima.upload.description.5" values={{strong: chunks => <strong>{chunks}</strong>}} /></p>
					<p><FormattedMessage id="sima.upload.description.6" values={{i: (chunks) => <i>{chunks}</i>}} /></p>
					<p><FormattedMessage id="sima.upload.description.7" values={{strong: chunks => <strong>{chunks}</strong>}} /></p>
					<p><FormattedMessage id="sima.upload.description.8" values={{b: chunks => <b>{chunks}</b>, p: chunks => <p>{chunks}</p>, div: chunks => <div>{chunks}</div>}}/></p>
					<p><FormattedMessage id="sima.upload.description.9" /></p>
					<p><FormattedMessage id="sima.upload.description.10" /></p>
					<p><FormattedMessage id="sima.upload.description.11" values={{strong: chunks => <strong>{chunks}</strong>}} /></p>
					<p><FormattedMessage id="sima.upload.description.12" values={{strong: chunks => <strong>{chunks}</strong>}} /></p>
					<p><span class="glyphicon glyphicon-alert" style={{color : "#efcc00"}}></span> <FormattedMessage id="sima.upload.description.13" values={{i: (chunks) => <i>{chunks}</i>}} /></p>
				</div>
				<div className="form-group col-md-12" id="attachments">{!!values.attachments ?
					<FieldArray name="attachments">
						{({insert, remove, push}) => {
							let currentRequestCount = 0;
							let currentRequests = {}
							if (!!props.attachments) {
								for (let file of props.attachments) {
									if (file.uploadedStatus !== "COMPLETE") {
										currentRequests[file.uploadedDate] = true;
									}
								}
								currentRequestCount = Object.keys(currentRequests).length;
							}
							return <>
								{values.attachments.map((attachment, index) => (
									<button key={index} type="button" className="bton bton-default btn-block text-center" style={{borderRadius:"20px", backgroundColor:"#f7f8fa", marginBottom:"4px", marginTop:"0px", position:"relative", display:"flex", alignItems:"center", padding:"8px"}}>
									<span className="glyphicon glyphicon-file" style={{fontSize:"1.2em", marginRight:"8px", marginLeft:"8px"}}>
									</span>
									<span className="truncate-text" style={{flex:"1", textAlign:"left"}}>{formatFileName(attachment.fileName)}</span>
									<span style={{whiteSpace:"nowrap"}}><i>{bytesToNearestUnitStr(attachment.fileSize, messages, 2)}</i> - {Math.floor(attachment.uploadProgress)}%</span>
									<span className="hidden-xs" style={{position:"absolute", marginLeft:"47px", marginRight:"47px", paddingBottom:"5px", height:"50px", width:"-webkit-fill-available", backgroundColor:"transparent", left:"0", verticalAlign:"bottom"}}>
										<span style={{borderBottom:"solid #335075 6px", display:"block", height:"100%", width: attachment.uploadStatus==="PENDING" && !!attachment.uploadProgress ? attachment.uploadProgress+"%" : "0%"}}>&nbsp;</span>
									</span>
									<span className="visible-xs hidden-sm hidden-md hidden-lg" style={{position:"absolute", marginLeft:"47px", marginRight:"47px", paddingBottom:"24px", height:"87px", width:"-webkit-fill-available", backgroundColor:"transparent", left:"0", verticalAlign:"bottom"}}>
										<span style={{borderBottom:"solid #335075 6px", display:"block", height:"100%", width: attachment.uploadStatus==="PENDING" && !!attachment.uploadProgress ? attachment.uploadProgress+"%" : "0%"}}>&nbsp;</span>
									</span>
									<span className="glyphicon glyphicon-trash" style={{fontSize:"1.2em", marginLeft:"8px", marginRight:"8px"}} onClick={() => {remove(index)}}></span>
								</button>
								))}
								<FileUpload
									crmDuaGuid={"crmDuaGuid"}
									attachments={values.attachments}
									forceParentUpdate={() => setFieldTouched("attachments", true, false)}
									maxFilesPerSubmission={constants.maxUploadLimitPerSubmission}
									disabled={((values?.attachments?.length ?? 0) >= constants.maxUploadLimitPerSubmission || currentRequestCount >= constants.maxConcurrentUploadRequests)}
									tempSubmissionId={props.tempSubmissionId}
								/>
							</>
						}}
					</FieldArray>
				: <></>
				}</div>
				<div style={{height:"25px"}}></div>
			</div>
		</>
	);
}